//@ts-nocheck
import React from 'react';
import Icon from '@ant-design/icons';

const QIcon = ({component, ...props}) => {
    return <Icon component={component} {...props} />
}

export default QIcon;